import { render, staticRenderFns } from "./DownloadRecord.vue?vue&type=template&id=d5622cc0&"
import script from "./DownloadRecord.vue?vue&type=script&lang=js&"
export * from "./DownloadRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports